import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IDistrict from '../interfaces/IDistrict';

export default function Edit() {     
  const {register, handleSubmit, control, setValue:setFormValue,getValues} = useForm<IDistrict>();
  const fields = [
    { name: 'id', type: 'hidden'},
    { name: 'name', type: 'string'},
    { name: 'cityId', type: 'selectAutoComplete', model: 'city', placeholder:'City' },
];
  
    return(
      <CrudEdit 
        model={'district'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'District successfully updated!'}  
        title={'Edit District'}
        getValues={getValues}
      />
    )
}